<template>
  <div class="container-fluid">
    <div class="row">
      <div class="stock-search-bar">
        <button class="barcode-scanner text-white" @click="openTables">
          <font-awesome-icon icon="fa-solid fa-table"/>
        </button>
        <font-awesome-icon class="search-icon position-absolute" icon="fa-solid fa-magnifying-glass"/>

        <!--        <input v-model="input" @keyup.enter="onBarcodeScanned(input)"-->
        <!--               class="ml-2 stock-search-field form-control"-->
        <!--               placeholder="PLU, Barcode,Description" type="text" ref="inputField" >-->

        <input v-model="input" @keyup.enter="onBarcodeScanned(input)"
               class="ml-2 stock-search-field form-control"
               placeholder="PLU, Barcode, Description, Description 2" type="text" ref="inputField" >

        <button @click="onBarcodeScanned(input)" type="button" class="barcode-scanner mx2 text-white">
          <font-awesome-icon icon="fa-solid fa-magnifying-glass"/>
        </button>

        <button @click="open" class="barcode-scanner viewOrder text-white">
          <span class="badge" v-if="saleUnits>0">{{ saleUnits }}</span>
          <font-awesome-icon icon="fa-solid fa-cart-shopping"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StockSearchBar",
  components: {},
  computed: {
    saleUnits() {
      return this.$store.getters.getSaleUnits
    },
    category() {
      return this.$store.getters.getCurrentCategory
    },
    subCategory() {
      return this.$store.getters.getSubCategory
    },
    sub2Category() {
      return this.$store.getters.getSubCategory2
    },
    isTabOpen() {
      return this.$store.getters.getIsTabOpen
    },
    systemSettings() {
      return this.$store.getters.getSystemSettings;
    },

  },
  data() {
    return {
      input: '',
    }
  },
  methods: {
    open() {
      this.$router.push({name: 'viewSale'})
    },
    search(e) {
      this.getStock()
    },
    openTables() {
      return this.$router.push({name: 'tables'})
    },
    addScaleItem(itemObj) {
      this.$store.dispatch('getStockSetting', itemObj.PLU).then(async (set) => {
        if (set.cookingLink) {
          this.$router.push({name: 'instruction', params: {plu: itemObj.PLU}})
          return;
        }
        let price = itemObj.SellingIncl;
        let specialPrice = this.$store.getters.getItemSpecialPrice(itemObj.PLU)
        if (specialPrice) {
          responses.showSuccess(`Special Detected`)
          price = specialPrice;
        }
        let tourismLevy = 0.0;
        if (set.tourism){
          let obj = { amount : price, incl : true }
          tourismLevy = await this.$store.dispatch('getTourismLevyAmount', obj);
        }
        let obj = {
          Plu: itemObj.PLU,
          Description: itemObj.Description,
          Qty: itemObj.Qty,
          tourismLevy,
          Unit: Number(price).toFixed(2),
          Line: Number(price * itemObj.Qty).toFixed(2),
          Discount: 0,
          vat: 0,
          instructions: []
        }
        this.$store.commit('addToCurrentSaleLines', obj)
        this.input = ''
      });
    },
    async protectedItems(protect){
      if (protect) {
        let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `salePasswordItem`);
        if (!isAllowed) return { allowed: false };
        if(isAllowed) {
          if(!isAllowed.allowed) {
            const supervisor = this.$store.getters.getCurrentUser.Username;
            return {allowed: true, supervisor: supervisor};
          }
          return isAllowed
        }
      }
      return { allowed: true };
    },

    addToSale(item) {
      return this.$store.dispatch('getStockSetting', item.PLU)
          .then(async (set) => {
            let cost = Number(item.InclCost.toFixed(2));
            let price = Number(item.SellingIncl.toFixed(2));
            let description = item.Description;

            const getQtyFromPrice = set.getQtyFromPrice;
            let quantity = 1;
            let authrorizedBy = '';

            const protect = await this.protectedItems(set.password_protected)
            if (!protect.allowed) return ;
            if(protect.allowed) {
              if(protect.supervisor){
                authrorizedBy = protect.supervisor
              }else {
                authrorizedBy = this.$store.getters.getCurrentUser.Username;
              }
            }

            if (cost > price) {
              const result = await Swal.fire({
                allowOutsideClick: false,
                icon: "warning",
                showCancelButton: true,
                showLoaderOnConfirm: true,
                title: `Cost price is greater than Selling price`,
                confirmButtonText: 'Proceed',
                focusConfirm: false,
              });

              if (!result.isConfirmed) {
                return;
              }
            }

            // Calculate quantity from price only if getQtyFromPrice is true
            if (getQtyFromPrice) {
              const { value: totalItemPrice } = await Swal.fire({
                title: 'Enter Total Item Price',
                input: 'number',
                icon : "question",
                inputLabel: 'Total Item Price',
                inputPlaceholder: 'Enter the total price for the items',
                showCancelButton: true,
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputValidator: (value) => {
                  if (!value || isNaN(value) || value <= 0) {
                    return 'Please enter a valid price!';
                  }
                }
              });

              if (totalItemPrice) {
                quantity = totalItemPrice / price; // Uses stock setting price

              }
            }

            // Prompt for description if required
            if (set.askForDescription || set.askForBoth) {
              description = await this.askForDescription(item);
            }

            // Prompt for price if required
            if (set.askForPrice || set.askForBoth) {
              price = await this.askForPrice(item);
            }

            // Redirect to cooking instructions if required
            if (set.cookingLink) {
              return this.$router.push({
                name: 'instruction',
                query: { plu: item.PLU, saleNumber: this.$route.query.saleNumber }
              });
            }

            // Apply special price if available
            let specialPrice = this.$store.getters.getItemSpecialPrice(item.PLU);
            if (specialPrice) {
              responses.showSuccess(`Special Detected`);
              price = specialPrice;
            }

            // Calculate tourism levy if applicable
            let tourismLevy = 0.0;
            if (set.tourism) {
              let obj = { amount: price, incl: true };
              tourismLevy = await this.$store.dispatch('getTourismLevyAmount', obj);
            }

            // Prepare sale object
            let obj = {
              Plu: item.PLU,
              Description: description,
              Qty: quantity,
              tourismLevy,
              Unit: price, //  Uses stock setting price per unit
              Line: price, // Total price
              Discount: 0,
              vat: 0,
              instructions: [],
              authorizedBy: authrorizedBy,
            };

            // Add to sale
            this.$store.commit('addToCurrentSaleLines', obj);

            return this.$store.dispatch(`calculateTipAmount`);
          });
    },
    askForPrice(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Selling Price`,
        html: `<h6 >Description : ${item.Description}</h6>
               <h6 >Current Price : ${$utils.formatMoney(item.SellingIncl)}</h6>
               <input type="number" step="0.01" id="selling-prc" class="swal2-input" placeholder="Selling Price" style="max-width: 70%">`,
        confirmButtonText: 'Set Price',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#selling-prc').value;
          if (!value) {
            Swal.showValidationMessage(`Please enter a valid Selling Price`)
          }
          return parseFloat(value);
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return parseFloat(item.SellingIncl.toFixed(2))
      })
    },
    askForDescription(item) {
      this.$store.commit('setIsTabOpen', true)
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Description`,
        html: `<h6 >Description : ${item.Description}</h6>
               <textarea id="desc-ask" class="swal2-input" placeholder="Description" style="max-width: 70%">`,
        confirmButtonText: 'Set Description',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#desc-ask').value
          if (!value || value.toString().trim() === "") {
            Swal.showValidationMessage(`Please enter a valid Description`)
          }
          return value;
        }
      }).then(result => {
        this.$store.commit('setIsTabOpen', false)
        if (result.isConfirmed) {
          return result.value;
        }
        return item.Description
      })
    },
    getStock() {
      this.$utils.showLoading()
      const query = {
        description: this.input,
        category: '',
        subCategory: '',
        sub2Category: ''
      }
      return this.$store.dispatch('searchDescription', query)
          .finally(() => this.$utils.hideLoading())
    },
    hasLetters(inputString) {
      return /[a-zA-Z]/.test(inputString);
    },
    async onBarcodeScanned(barcode) {

      if (barcode.slice(-5) === `Enter`) {
        barcode = barcode.slice(0, -5);
      }
      if (!this.isTabOpen) {
        try {
          this.$store.commit(`setIsTabOpen`, true)
          let item;
          item = this.$store.getters.getByPlu(barcode)

          if (!item) {
            item = this.$store.getters.getByPlu(barcode.slice(1))
          }

          if (!item) {
            let itemBarcode = barcode.slice(0, -1);
            item = this.$store.getters.getByPlu(itemBarcode)
          }

          let settings = this.$store.getters.getDeviceSettings;
          let barcodeMakesPrice = this.systemSettings.priceMakesPrice;

          let flag = barcode.substring(0, 2);


          if (!item && barcode.length === 13 && settings && settings.Flag.toString() === flag) {
            let scaleItemPLU = barcode.toString().substring(2, 6);
            item = this.$store.getters.getByPlu(scaleItemPLU)
     
            if (item) {
              let barcodePrice = barcode.toString().substring(6, 12);
              if (settings.checkDigit) {
                barcodePrice = barcode.toString().slice(0, 6) + barcode.slice(7);
                barcodePrice = barcodePrice.toString().substring(6, 11)
              }
              let sellingIncl = item.SellingIncl;
              if (barcodeMakesPrice) {
               
                barcodePrice = barcodePrice.substring(0, barcodePrice.length - 2) + '.' + barcodePrice.substring(barcodePrice.length - 2, 6);
                barcodePrice = Number(barcodePrice);
                let qty = barcodePrice / sellingIncl;
                item.Qty = parseFloat(qty.toFixed(3));
              }else {
                barcodePrice = barcodePrice.substring(0, barcodePrice.length - 3) + '.' + barcodePrice.substring(barcodePrice.length - 3, 6);
                barcodePrice = Number(barcodePrice);
                let qty = barcodePrice;
                item.Qty = parseFloat(qty.toFixed(3));

              }
              return this.addScaleItem(item);
            }
          }

          if (item) {
            this.addToSale(item)
            this.input = ''
          } else {
            return this.getStock();
          }
        } finally {
          this.$store.commit(`setIsTabOpen`, false)
        }
      } else {
        this.getStock()
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.inputField.focus();
    });
  },
  created() {
    // this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  destroyed() {
    // this.$barcodeScanner.destroy()
  }
}
</script>

<style lang="scss" scoped>
.row {
  background: #ffffff;
  padding: 0 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

button {
  background: #0092f7;
  border: none;
  transition: all 0.3s ease;

  &:hover {
    background: #0084e0;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

.stock-search-bar {
  background: #ffffff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  border-radius: 12px;
  justify-content: flex-start;
  position: relative;
  gap: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);

  .barcode-scanner {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    font-size: 20px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 146, 247, 0.2);
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      transform: rotate(30deg);
      animation: shine 4s infinite;
    }

    &:hover {
      background: #0084e0;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 146, 247, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .viewOrder {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    width: 44px;
    height: 44px;

    .badge {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: -3px;
      right: -3px;
      font-size: 11px;
      min-width: 20px;
      height: 20px;
      padding: 0 6px;
      background: #0092f7;
      border-radius: 10px;
      color: rgb(221, 158, 64);
      font-weight: 600;
      box-shadow: 0 2px 4px rgba(0, 146, 247, 0.3);
      border: 2px solid #e0ac1c;
    }
  }

  .search-icon {
    left: 72px;
    margin-left: 15px;
    font-size: 16px;
    color: #6c757d;
    z-index: 1;
  }

  .stock-search-field {
    margin-left: 10px;
    height: 44px;
    width: 100%;
    border-radius: 12px;
    padding: 0 16px 0 40px;
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    font-size: 0.95rem;
    background: #f8f9fa;
    color: #2c3e50;

    &:hover {
      background: #ffffff;
      border-color: rgba(0, 146, 247, 0.2);
    }

    &:focus {
      background: #ffffff;
      border-color: #0092f7;
      box-shadow: 0 0 0 3px rgba(0, 146, 247, 0.1);
    }

    &::placeholder {
      color: #6c757d;
      font-weight: 400;
    }
  }
}

@keyframes shine {
  0% {
    transform: translateX(-100%) rotate(30deg);
  }
  15%, 100% {
    transform: translateX(100%) rotate(30deg);
  }
}
</style>
